export default {"src":"/_next/static/media/Business-Loan-Calc-Icon.97dfb4e1.svg","height":27,"width":23};